import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material'
import {
  useVesselContext,
  vesselDialogs,
} from '../../../Contexts/Modules/SampleModule/VesselModule'
import { useNavigate } from 'react-router-dom'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import { LoadingButton } from '@mui/lab'
import { useStuartMutate } from '../../../APIs/Hooks/PhpAPIHooks'

function DestroyConfirmDialog() {
  const { openDialog, setOpenDialog, vesselQuery, setFields, fields } =
    useVesselContext()
  const navigate = useNavigate()
  const { setMessage } = useMessagePopupContext()
  const { mutate: destroy, isLoading } = useStuartMutate(
    `/vessel/destroyVessel.php?VesselID=${vesselQuery.data?.VesselID}&Confirm=true&VesselCount=${fields?.destroy?.VesselsToBeDestroyed}&SampleCount=${fields?.destroy?.SamplesToBeDestroyed}&DestructionReason=${fields?.destroy?.reason}`,
    (data) => {
      if (data?.Success) {
        setFields((f: any) => {
          return {
            ...f,
            destroy: data,
          }
        })
        setOpenDialog(undefined)
        navigate('../../holding/' + vesselQuery.data?.HoldingID)
      } else {
        setMessage({
          subject: 'Error',
          severity: 'warning',
          message:
            data?.message ??
            'An unexpected error occurred destroying the vessel',
        })
      }
    },
  )
  return (
    <Dialog
      open={openDialog === vesselDialogs.DESTROY_CONFIRM}
      onClose={() => setOpenDialog(undefined)}
    >
      <DialogTitle>{'Confirm Vessel Destruction'}</DialogTitle>
      <DialogContent>
        Destroying this vessel will destroy{' '}
        {fields?.destroy?.VesselsToBeDestroyed} vessels and{' '}
        {fields?.destroy?.SamplesToBeDestroyed} samples. <br />
        Please provide a reason for destruction.
        <TextField
          autoFocus
          margin="normal"
          onChange={(e: any) =>
            setFields((fields: any) => ({
              ...fields,
              destroy: {
                ...fields?.destroy,
                reason: e.target.value,
              },
            }))
          }
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpenDialog(undefined)}
          color="error"
          disabled={isLoading}
        >
          Cancel
        </Button>
        <LoadingButton
          disabled={!fields?.destroy?.reason}
          onClick={() => destroy()}
          color="warning"
          loading={isLoading}
        >
          Destroy Vessel
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default DestroyConfirmDialog
